import React, { useState, useEffect, useContext } from 'react'
import Table from "components/Table/Table";
import RedemptionAPI from 'apis/redemption/redemption';
import Context from 'context/context';
import searchIcon from "assets/img/Search_Icon.png";
import { Styles } from './styles'
import { toast } from "react-toastify";
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { blockInvalidChar } from "helpers/blockInvalidChar";
import access from 'config/access';

// matrerial ui
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from "@material-ui/core/Dialog";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import * as moment from "moment";
import { CSVLink } from 'react-csv';

// material-ui icons
import Grid from "@material-ui/core/Grid";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

//Helpes
import useDebounce from "helpers/useDebounce";
import { blockInvalidCharForText } from 'helpers/blockInvalidCharForText';
import {dateFormat, pointsFormat} from "helpers/dataFormat"
import { exportHeaders } from "./export";

// custom TextField
const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormLabel-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: 20,
            },
            "&.MuiOutlinedInput-root": {
                marginTop: 0,
                borderRadius: 20,
                background: "#ededed",
            },
        },
    },
})(TextField);


function Redemption() {
    const { state, dispatch } = useContext(Context)
    const { getRedemption, search, getReasonDescription, cancelRedemption,Export } = RedemptionAPI()
    const [searchValue, setSearchValue] = useState("")
    const [offset, setOffset] = useState(1)
    const [data, setData] = useState([])
    const [count, setCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const [dialogOpen, setDialogOpen] = useState(false)
    const searchBounceValues = useDebounce(searchValue)
    const [descriptionList, setDescriptionList] = useState([])
    const [selectedRecord, setSelectedRecord] = useState({})
    const [errorText, setErrorText] = useState('')
    const [reason, setReason] = useState('')
    const [type, setType] = useState('Pending')
    const [exportData, setExportData] = useState([]);
    const classes = Styles()
    const history = useHistory()
    const { t , i18n}= useTranslation();
    useEffect(() => {
        dispatch({
            type: "SET_PATHNAME",
            payload: ["HOME", "ADMIN", "Redemption Details"],
        });
    }, []);

    useEffect(() => {
        getReasonDescriptionList()
    }, [])

    useEffect(() => {
        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch()
        } else {
            getRedemptionDetails()
        }
    }, [offset, searchBounceValues, type])

    async function getRedemptionDetails() {
        try {
            setLoading(true)
            let values = {
                offset: (offset - 1) * 10,
                limit: 10,
                type
            }
            let res = await getRedemption(values)
            if (res) {
                setData(res.data)
                setCount(res.count)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            throw error
        }
    }

    async function handleSearch() {
        try {
            setLoading(true)
            let values = {
                offset: (offset - 1) * 10,
                limit: 10,
                searchValue,
                type
            }
            let res = await search(values)
            if (res) {
                setData(res.data)
                setCount(res.count)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            throw error
        }
    }

    async function getReasonDescriptionList() {
        try {
            let data = await getReasonDescription()
            if (data) {
                setDescriptionList(data["data"])
            }
        } catch (err) {
            console.log({ err });
        }
    }

    const handleCancelRedemption = async () => {
        try {

            if (reason.length == 0) {
                return setErrorText('please select the reason')
            }
            dispatch({ type: 'SET_LOADING', payload: true })
            const values = {
                ...selectedRecord,
                reason,
                cancelledBy: state?.userInfo?.user_id
            }
            let updatedData = await cancelRedemption(values)
            if (updatedData) {
                toast.success('Cancelled Successfully')
            }
            setReason('')
            setDialogOpen(false)
            dispatch({ type: 'SET_LOADING', payload: false })
            if (searchBounceValues && searchBounceValues.length > 0) {
                handleSearch()
            } else {
                getRedemptionDetails()
            }
        } catch (error) {
            console.log({ error });
        }
    }

    const handlePagination = (value) => {
        setOffset(value);
    };

    const handleExport = async () => {
        let values = {};
    // Conditionally add filterValue
        if ( type=="Cancelled" ) {
          values = { ...values, filtervalue:"Cancelled" };
        }

        if ( type=="Pending" ) {
            values = { ...values, filtervalue:"Pending" };
          }
       
        
        
        if (searchValue) {
          values = { ...values, searchValue,type };
        }
    
        dispatch({ type: "SET_LOADING", payload: true });
        let res = await Export(values);
        console.log(res,"ragav")
        if (res && res.data) {
            // setIsLoading(false);
            setExportData(res.data);
            dispatch({ type: "SET_LOADING", payload: false });
           
            if (res.data.length === 0) {
              toast.success(t("No Data Found"), { toastId: "no-report-date" });
              return false;
            }
           
            return true;
          }
        }

    return (
        <>
            <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
                <Grid>
                    <CssTextField
                        id="enterPassword"
                        placeholder={t("Search for Loyalty Id")}
                        onKeyDown={blockInvalidChar}
                        type={"number"}
              onWheel={(e) => e.target.blur()}
                        variant="outlined"
                        autoComplete="off"
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue("");
                                                setOffset(1);
                                                getRedemptionDetails();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=""
                                            width="20px"
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            ),
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            e.target.value.replace(/\s+/g, "").length == 0
                                ? setSearchValue("")
                                : setSearchValue(e.target.value);
                            if (e.target.value.length == 0) {
                                getRedemptionDetails();
                            }
                        }}
                        onClick={() => {
                            setOffset(1);
                        }}
                    />
                    <FormControl component="fieldset">
                        <RadioGroup
                            aria-label="type"
                            name="type"
                            value={type}
                            onChange={(e) => {
                                setOffset(1)
                                setType(e.target.value)
                            }}
                            className={classes.radioGroup}
                        >
                            <div>
                                <FormControlLabel
                                    value="Pending"
                                    control={
                                        <Radio className={classes.radioButton} disableRipple={true} />
                                    }
                                    label={t("Pending")}
                                />
                            </div>
                            <div style={{ marginLeft: 10 }}>
                                <FormControlLabel
                                    value="Cancelled"
                                    control={
                                        <Radio className={classes.radioButton} disableRipple={true} />
                                    }
                                    label={t("Cancelled")}
                                />
                            </div>
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <CSVLink
            id="csv"
            data={exportData
               }
             headers={exportHeaders}
         filename={
              `Redemption-Details` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>   

            </Grid>

            <div style={{ marginTop: 20 }}>
                {!loading ? <Table
                    headings={[
                        "Member ID",
                        "Redemption Date",
                        "Requested Redeemed Points",
                        "Status",
                        "JDE Approval Status",
                        "Cancelled By",
                        ""
                    ]}
                    data={data &&
                        data.length > 0 &&
                        data.map((p) => [
                            [
                                <span
                                    className={classes.tableSpan}
                                    onClick={() => history.push('/dashboard/view-redemption-detail', { data: p })}
                                >
                                    {p?.loyalty_id}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                    onClick={() => history.push('/dashboard/view-redemption-detail', { data: p })}
                                >
                                    {dateFormat(p?.date_of_transaction,i18n.language)}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                    onClick={() => history.push('/dashboard/view-redemption-detail', { data: p })}
                                >
                                    {pointsFormat(p?.points_redeemed,i18n.language)}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                    onClick={() => history.push('/dashboard/view-redemption-detail', { data: p })}
                                >
                                    {t(p?.transaction_status)}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                    onClick={() => history.push('/dashboard/view-redemption-detail', { data: p })}
                                >
                                    {t(p?.redemption_approval_status)}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                    onClick={() => history.push('/dashboard/view-redemption-detail', { data: p })}
                                >
                                    {p?.altered_by ? p?.altered_by : "--"}
                                </span>
                            ],
                            [
                                p?.transaction_status?.toLowerCase() !== 'cancelled' &&
                                <span
                                    className={classes.cancelBtn}
                                    aria-disabled={!state?.userInfo?.editAction}
                                    onClick={()=> {
                                        if(state?.userInfo?.editAction){
                                        setSelectedRecord(p)
                                        setDialogOpen(true)
                                        return;
                                    }
                                  else{
                                    toast.error(state.userInfo?.editAccess)
                                  return;
                                }}}
                                >
                                   {t('Cancel')}
                                </span>
                            ]
                        ])}
                    offset={offset}
                    count={
                        (count / 10) % 1 == 0
                            ? Math.floor(count / 10)
                            : Math.floor(count / 10 + 1)
                    }
                    handlePagination={handlePagination}
                /> :
                    <div className={classes.loadingDiv}>
                        <h2>{t('Loading...')}</h2>
                    </div>}
            </div>

            <Dialog
                aria-labelledby="simple-dialog-title"
                open={dialogOpen}
                style={{ fontFamily: "Segoe-ui" }}
            >
                <div className={classes.dialogParentDiv}>
                    <div className={classes.parentText}>
                        {" "}
                        By choosing Cancel option, you are cancelling the redemption of Points: <b>{selectedRecord?.points_redeemed?.toLocaleString()}</b> will be reverted back to the Member Id: <b>{selectedRecord?.loyalty_id}</b> points balance. Do you want to proceed?
                    </div>
                    <br />
                    <span className={classes.subParentText}>{t('Reason for Cancellation')}<span style={{ color: 'red' }}>*</span></span>
                    <CssTextField
                        id="reason"
                        placeholder={''}
                        fullWidth
                        onKeyDown={blockInvalidCharForText}
                        select
                        variant="outlined"
                        autoComplete="off"
                        className={classes.selectInput}
                        value={reason}
                        onChange={(e) => {
                            setReason(e.target.value)
                        }}
                        helperText={errorText}
                        error={errorText.length > 0 ? true : false}
                    >
                        {descriptionList && descriptionList.length > 0 && descriptionList.map(i => (
                            <MenuItem key={i.id} value={i.reason_description}>{t(i.reason_description)}</MenuItem>
                        ))}
                    </CssTextField>
                    <br /><br />
                    <Grid container spacing={0}>
                        <Grid item xs={6}>
                            <Button
                                className={classes.noBtn}
                                disabled={state?.loading}
                                onClick={() => {
                                    setDialogOpen(false)
                                    setReason('')
                                    setErrorText('')
                                }}
                            >
                                {t('No')}
                            </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.proceedBtnGrid}>
                            <Button
                                className={classes.proceedBtn}
                                disabled={state?.loading}
                                onClick={() => {
                                    handleCancelRedemption()
                                }}
                            >
                                {t('Yes')}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Dialog>
        </>
    )
}

export default Redemption